
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSwitch, AppSelect, AppButton } from '@/components';
import { useGameMatchAdd } from '@/modules/game/match/model/add';
import { GameMatchOptions, GameMatchType } from '@/modules/game/match/model/mixins';
import { ROUTE_NAME_GAME } from '@/modules/game/router';

export default defineComponent({
    name: ROUTE_NAME_GAME.MATCH.ADD,
    components: { AppFormRow, AppInput, AppCard, AppSwitch, AppSelect, AppButton },
    setup() {
        const { model, v$, actions } = useGameMatchAdd();

        return { model, v$, GameMatchOptions, GameMatchType, actions };
    }
});
